import { ExpandLessRounded, ExpandMoreRounded } from '@mui/icons-material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { ReactComponent as RoundedEdit } from '../../../../assets/roundedEdit.svg';
import { ReactComponent as RoundedDelete } from '../../../../assets/roundedDelete.svg';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function DocsAccordian({ hasActionButtons, actionButtons, classname, showDesc, style, title, children,docsCount }) {
    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div style={{ width: "100%", ...style }} className={classname}>
            <Accordion style={{ borderRadius: "4px" }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary style={{ backgroundColor: "transparent" }} aria-controls="panel1d-content" id="panel1d-header">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ display: "flex" }}>
                            <div>
                                <Typography variant="h3" sx={{ color: "var(--color-primary)" }}>{title} </Typography> 
                              
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                {expanded ? <ExpandLessRounded color='#000000' style={{ opacity: "0.5" }} /> : <ExpandMoreRounded color='#000000' style={{ opacity: "0.5" }} />}
                            </div>
                            <div className=' bxShadow counterCircle'> {docsCount} </div>
                        </div>
                        {hasActionButtons ? <div>
                            {/* <RoundedEdit style={{ marginRight: "10px" }} />
                            <RoundedDelete /> */}
                            {actionButtons}
                        </div> : ""}
                    </div>
                    <div style={{ marginTop: "5px" }}>
                        {showDesc ? <div>{showDesc}</div> : ""}
                    </div>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%" }}>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}